<div class="pop" [ngClass]="{'modeone': isModeOne, 'modetwo': isModeTwo}">
  <header>
    <ng-container>
      <div class="icon" inlineSVG="sot/sot-icon.svg#sot-coupon-ani" [setSVGAttributes]="{class: 'box-icon'}"></div>
    </ng-container>
    <h1 langkey="coupons_manual_enter_text"></h1>
  </header>
  <sot-numberPad #numberPad [requiredLength]="couponCodeLength" [minLength]="couponCodeMinLength" [maxLength]="couponCodeLength" [displayDots]="false"
    [validateFirstChar]="false" [showSeparators]="false"></sot-numberPad>
  <footer class="buttons">
    <button mat-button class="btn goback insert" (click)="cancel()">
      <div inlineSVG="sot/sot-icon.svg#sot-close" flex [setSVGAttributes]="{class: 'btn-icon'}"></div>
      <span langkey="button_cancel"></span>
    </button>
    <button mat-button [class.disabled]="submitDisabled" (click)="submit()" class="btn goforward">
      <span langkey="button_continue"></span>
      <div inlineSVG="sot/sot-icon.svg#sot-forward" flex [setSVGAttributes]="{class: 'btn-icon'}"></div>
    </button>
  </footer>
</div>